import MyWorkProto from "../../my-work-properties/my-work-proto"
import Task from "../task"
import {MY_WORK_ITEM_AS_TASK} from "../../my-work-properties/my-work-types"
import DatetimeUtils from "../../../gd/utils/datetime-utils"

export default class MyWorkTaskAssigned extends MyWorkProto {

    private task: Task

    constructor(task: Task) {
        super()

        this.task = task
    }

    get myWorkId() {
        return 't-as-'+this.task.id
    }

    get myWorkType() {return MY_WORK_ITEM_AS_TASK}

    get title() {return this.task.title}

    get isNew() {
        return false
    }

    get isPastdue() {
        return this.endDate ? DatetimeUtils.isBeforeToday(this.endDate) : this.startDate ? DatetimeUtils.isBeforeToday(this.startDate) : false
    }

    get fromUserId() {
        return this.task.createdByUserId
    }

    // get canMoveToInbox() { return true }
    // get canMoveToSomeday() { return true }
    // get canChangeDate() { return true }
    get canChangePriority() { return true }

    get dateCreated() {
        return this.task.momentCreated
    }

    get isDateRange() {return true}

    get startDate() {
        return this.task.startDate
    }

    get endDate() {
        return this.task.endDate
    }

    get priority() {return this.task.priority}

    // toJSON() {
    //     let res = {}
    //
    //     _.mapKeys(this, (value, key)=>{
    //         switch (key) {
    //             case 'myWorkDateCreated':
    //                 res[key] = value ? DatetimeUtils.momentToUTCISODatetime(value) : null
    //                 break
    //
    //             default: res[key] = value
    //         }
    //     })
    //
    //     return res
    // }
}
